// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&family=Roboto+Slab:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-sans: 'Segoe UI', 'Arial', sans-serif;
  --font-serif: 'Roboto Slab', 'Georgia', serif;
  --text-color: #2c2c2c;
  --heading-color: #2c3e50;
  --accent-color: #007BFF;
  --accent-dark: #0056b3;
  --background-color: #ffffff;
  --border-color: #ccc;
  --highlight-color: #e6f0ff;
}

/* NOTE: the element-level base resets below (body / h1-h6 / p / a / inputs /
   label / table) are DISABLED globally (wrapped in a comment) so importing this
   master does not restyle existing pages. The master contributes :root variables
   and the component CLASSES further down. Re-enable selectively if you later want a
   global typographic/table reset. */
/*
body {
    font-family: var(--font-sans);
    color: var(--text-color);
    font-size: 16px;
    line-height: 1.6;
    background-color: var(--background-color);
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-serif);
  color: var(--heading-color);
  margin: 0.5em 0;
}

h1 { font-size: 2.5em; font-weight: 700; }
h2 { font-size: 2em; font-weight: 600; }
h3 { font-size: 1.6em; font-weight: 600; }
h4 { font-size: 1.3em; font-weight: 500; }
h5 { font-size: 1.1em; font-weight: 500; }
h6 { font-size: 1em; font-weight: 400; }

p {
  margin-bottom: 1em;
}

a {
  color: var(--accent-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

input[type="text"],
input[type="number"],
input[type="email"],
input[type="password"],
select,
textarea {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background-color: #fff;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

input:focus,
select:focus,
textarea:focus {
  border-color: var(--accent-color);
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: var(--heading-color);
}

select {
  background-color: #fff;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M70 100 L100 40 H40 Z' fill='%23007BFF'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2em;
  font-size: 15px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

thead {
  background-color: var(--highlight-color);
}

th, td {
  padding: 12px 16px;
  border: 1px solid #ddd;
  text-align: left;
}

th {
  font-weight: 600;
  color: var(--heading-color);
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}
*/
/* ---- end disabled element resets ---- */

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 30px;
}

.divider {
  height: 1px;
  background-color: #ccc;
  margin: 30px 0;
}

.section-header {
  border-bottom: 2px solid var(--accent-color);
  padding-bottom: 6px;
  margin-bottom: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--accent-color);
  padding: 10px 20px;
  color: white;
  height: 30px;
}

.logo img {
  height: 40px;
}

.nav-buttons {
  display: flex;
  height: 30px;
  gap: 15px;
}

.nav-button {
  background-color: white;
  color: var(--accent-color);
  padding: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
}

.nav-button:hover {
  background-color: var(--accent-dark);
  color: white;
}

button,
.btn {
  background-color: var(--accent-color);
  color: white;
  border: none;
  padding: 5px 5px;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover,
.btn:hover {
  background-color: var(--accent-dark);
}

.btn-outline {
  background-color: transparent;
  color: var(--accent-color);
  border: 2px solid var(--accent-color);
}

.btn-outline:hover {
  background-color: var(--accent-color);
  color: white;
}

.btn-group {
  display: flex;
  gap: 12px;
}

.cssbuttons-io-button {
  background: var(--accent-color);
  color: white;
  font-family: inherit;
  padding: 0.35em 1.2em 0.35em 1.2em;
  font-size: 17px;
  font-weight: 500;
  border-radius: 0.3em;
  border: none;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  box-shadow: inset 0 0 1.6em -0.6em var(--accent-dark);
  overflow: hidden;
  position: relative;
  height: 2.8em;
  padding-right: 3.3em;
  cursor: pointer;
}

.cssbuttons-io-button .icon {
  background: white;
  margin-left: 1em;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.2em;
  width: 2.2em;
  border-radius: 0.7em;
  box-shadow: 0.1em 0.1em 0.6em 0.2em var(--accent-dark);
  right: 0.3em;
  transition: all 0.3s;
}

.cssbuttons-io-button:hover .icon {
  width: calc(100% - 0.6em);
}

.cssbuttons-io-button .icon svg {
  width: 1.1em;
  transition: transform 0.3s;
  color: var(--accent-dark);
}

.cssbuttons-io-button:hover .icon svg {
  transform: translateX(0.1em);
}

.cssbuttons-io-button:active .icon {
  transform: scale(0.95);
}

/* Chat Toggle Button Styles */

.chat-toggle-wrapper {
  position: relative;
  display: inline-block;
  margin: 0px;
}

.chat-toggle-button {
  background-color: #ffffff;
  border: none;
  padding: 0px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.chat-toggle-button:hover {
  background-color: #ffffff;
}

.chat-toggle-icon {
  width: 24px;
  height: 24px;
}

.chat-toggle-tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 6px;
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 100;
}

.chat-toggle-tooltip::after {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #333 transparent;
}

`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAEA;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;;;oCAIoC;AACpC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0GC;AACD,0CAA0C;;AAE1C;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,sDAAsD;EACtD,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&family=Roboto+Slab:wght@500;600&display=swap');\n\n:root {\n  --font-sans: 'Segoe UI', 'Arial', sans-serif;\n  --font-serif: 'Roboto Slab', 'Georgia', serif;\n  --text-color: #2c2c2c;\n  --heading-color: #2c3e50;\n  --accent-color: #007BFF;\n  --accent-dark: #0056b3;\n  --background-color: #ffffff;\n  --border-color: #ccc;\n  --highlight-color: #e6f0ff;\n}\n\n/* NOTE: the element-level base resets below (body / h1-h6 / p / a / inputs /\n   label / table) are DISABLED globally (wrapped in a comment) so importing this\n   master does not restyle existing pages. The master contributes :root variables\n   and the component CLASSES further down. Re-enable selectively if you later want a\n   global typographic/table reset. */\n/*\nbody {\n    font-family: var(--font-sans);\n    color: var(--text-color);\n    font-size: 16px;\n    line-height: 1.6;\n    background-color: var(--background-color);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-serif);\n  color: var(--heading-color);\n  margin: 0.5em 0;\n}\n\nh1 { font-size: 2.5em; font-weight: 700; }\nh2 { font-size: 2em; font-weight: 600; }\nh3 { font-size: 1.6em; font-weight: 600; }\nh4 { font-size: 1.3em; font-weight: 500; }\nh5 { font-size: 1.1em; font-weight: 500; }\nh6 { font-size: 1em; font-weight: 400; }\n\np {\n  margin-bottom: 1em;\n}\n\na {\n  color: var(--accent-color);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\nselect,\ntextarea {\n  width: 100%;\n  padding: 10px;\n  font-size: 15px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background-color: #fff;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: var(--accent-color);\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: var(--heading-color);\n}\n\nselect {\n  background-color: #fff;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M70 100 L100 40 H40 Z' fill='%23007BFF'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 2em;\n  font-size: 15px;\n  background-color: #fff;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\nthead {\n  background-color: var(--highlight-color);\n}\n\nth, td {\n  padding: 12px 16px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\nth {\n  font-weight: 600;\n  color: var(--heading-color);\n}\n\ntr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntr:hover {\n  background-color: #f1f1f1;\n}\n*/\n/* ---- end disabled element resets ---- */\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.card {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  margin-bottom: 30px;\n}\n\n.divider {\n  height: 1px;\n  background-color: #ccc;\n  margin: 30px 0;\n}\n\n.section-header {\n  border-bottom: 2px solid var(--accent-color);\n  padding-bottom: 6px;\n  margin-bottom: 20px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: var(--accent-color);\n  padding: 10px 20px;\n  color: white;\n  height: 30px;\n}\n\n.logo img {\n  height: 40px;\n}\n\n.nav-buttons {\n  display: flex;\n  height: 30px;\n  gap: 15px;\n}\n\n.nav-button {\n  background-color: white;\n  color: var(--accent-color);\n  padding: 8px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 12px;\n}\n\n.nav-button:hover {\n  background-color: var(--accent-dark);\n  color: white;\n}\n\nbutton,\n.btn {\n  background-color: var(--accent-color);\n  color: white;\n  border: none;\n  padding: 5px 5px;\n  font-size: 15px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover,\n.btn:hover {\n  background-color: var(--accent-dark);\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--accent-color);\n  border: 2px solid var(--accent-color);\n}\n\n.btn-outline:hover {\n  background-color: var(--accent-color);\n  color: white;\n}\n\n.btn-group {\n  display: flex;\n  gap: 12px;\n}\n\n.cssbuttons-io-button {\n  background: var(--accent-color);\n  color: white;\n  font-family: inherit;\n  padding: 0.35em 1.2em 0.35em 1.2em;\n  font-size: 17px;\n  font-weight: 500;\n  border-radius: 0.3em;\n  border: none;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  box-shadow: inset 0 0 1.6em -0.6em var(--accent-dark);\n  overflow: hidden;\n  position: relative;\n  height: 2.8em;\n  padding-right: 3.3em;\n  cursor: pointer;\n}\n\n.cssbuttons-io-button .icon {\n  background: white;\n  margin-left: 1em;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.2em;\n  width: 2.2em;\n  border-radius: 0.7em;\n  box-shadow: 0.1em 0.1em 0.6em 0.2em var(--accent-dark);\n  right: 0.3em;\n  transition: all 0.3s;\n}\n\n.cssbuttons-io-button:hover .icon {\n  width: calc(100% - 0.6em);\n}\n\n.cssbuttons-io-button .icon svg {\n  width: 1.1em;\n  transition: transform 0.3s;\n  color: var(--accent-dark);\n}\n\n.cssbuttons-io-button:hover .icon svg {\n  transform: translateX(0.1em);\n}\n\n.cssbuttons-io-button:active .icon {\n  transform: scale(0.95);\n}\n\n/* Chat Toggle Button Styles */\n\n.chat-toggle-wrapper {\n  position: relative;\n  display: inline-block;\n  margin: 0px;\n}\n\n.chat-toggle-button {\n  background-color: #ffffff;\n  border: none;\n  padding: 0px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s ease;\n}\n\n.chat-toggle-button:hover {\n  background-color: #ffffff;\n}\n\n.chat-toggle-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.chat-toggle-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 6px;\n  background-color: #333;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  z-index: 100;\n}\n\n.chat-toggle-tooltip::after {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent #333 transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
